import React from "react";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { LocaleConsumer } from "contexts/locale-context";
import { fromRenderProps, compose, onlyUpdateForKeys } from "recompose";
import withLocale from "system/withLocale";
import styled from "styled-components";
import NavGnb from "./NavGnb";
import NavLnb from "./NavLnb";

const Nav = styled.header`
  position: relative;

  &.no_lnb {
    border-bottom: 1px solid #d7d7d7;
  }
`;

const Header = ({ location, noLnb, lang, match }) => {
  const locale = localStorage.getItem("ctcrLocale");
  const urlData = [
    {
      id: 0,
      name: `${lang.navigation[0].name}`,
      url: `/${locale}/about/introduce`,
      children: [
        {
          id: 0,
          name: `${lang.navigation[0].children[0]}`,
          url: `/${locale}/about/introduce`,
          view: null
        },
        {
          id: 1,
          name: `${lang.navigation[0].children[1]}`,
          url: `/${locale}/about/meaning`,
          view: null
        },
        {
          id: 2,
          name: `${lang.navigation[0].children[2]}`,
          url: `/${locale}/about/process`,
          view: null
        },
        {
          id: 3,
          name: `${lang.navigation[0].children[3]}`,
          url: `/${locale}/about/subjectguide`,
          view: null
        },
        {
          id: 4,
          name: `${lang.navigation[0].children[4]}`,
          url: `/${locale}/about/appguide`,
          view: null
        }
      ]
    },
    {
      id: 1,
      name: `${lang.navigation[1].name}`,
      url: `/${locale}/studyinfo/recruitment`,
      children: [
        {
          id: 0,
          name: `${lang.navigation[1].children[0]}`,
          url: `/${locale}/studyinfo/recruitment`,
          write: `/${locale}/studyinfo/recruitmentWrite`,
          write2: `/${locale}/studyinfo/recruitmentWriteMember`,
          view: `/${locale}/studyinfo/recruitmentView`
        }
      ]
    },
    {
      id: 2,
      name: `${lang.navigation[2].name}`,
      url: `/${locale}/contact/faq`,
      children: [
        {
          id: 0,
          name: `${lang.navigation[2].children[0]}`,
          url: `/${locale}/contact/faq`,
          view: null
        },
        {
          id: 1,
          name: `${lang.navigation[2].children[1]}`,
          url: `/${locale}/contact/location`,
          view: null
        }
      ]
    },
    {
      id: 3,
      name: `${lang.navigation[3].name}`,
      url: `/${locale}/myinfo/history`,
      children: [
        {
          id: 0,
          name: `${lang.navigation[3].children[0]}`,
          url: `/${locale}/myinfo/userinfo`,
          write: `/${locale}/myinfo/userModify`
        },
        {
          id: 1,
          name: `${lang.navigation[3].children[1]}`,
          url: `/${locale}/myinfo/apply`,
          write: `/${locale}/myinfo/applyModify`
        },
        {
          id: 2,
          name: `${lang.navigation[3].children[2]}`,
          url: `/${locale}/myinfo/history`,
          view: null
        }
        // {
        //   id: 3,

        //   name: `${lang.navigation[3].children[3]}`,
        //   url: `/${locale}/myinfo/qna`,
        //   write: `/${locale}/myinfo/qnaWrite`,
        //   view: `/${locale}/myinfo/qnaView`
        // }
      ]
    }
  ];

  // Gnb 메뉴명 분리
  const navName = path => {
    const menu = path.replace(/^\//g, "").split("/");
    return menu[1];
  };

  const gnbActive = navName(location.pathname); // 현재 Gnb 메뉴
  const lnbData = urlData.filter(menu => gnbActive === navName(menu.url)); // Gnb메뉴에 해당하는 데이터 값 필터링
  let lnbMenu = lnbData.length > 0 ? lnbData[0].children : null; // lnb 메뉴 리스트

  if (gnbActive === "about" && locale !== "kr") {
    // 한국어 버전에만 서울대학교병원 앱 이용안내 메뉴 활성화
    lnbMenu = lnbMenu.filter(lnb => lnb.id !== 4);
  }

  return (
    <Nav className={noLnb ? "no_lnb" : ""}>
      <NavGnb urlData={urlData} navName={navName} gnbActive={gnbActive} />
      {!noLnb && <NavLnb urlData={lnbMenu} />}
    </Nav>
  );
};

const enhance = compose(
  withRouter,
  injectIntl,
  withLocale,
  onlyUpdateForKeys(["location", "match", "noLnb", "lang"])
);

export default fromRenderProps(LocaleConsumer, ({ state, actions }) => ({
  locale: state.locale,
  setValue: actions.setValue
}))(enhance(Header));
